module.exports = __webpack_public_path__ + "img/symphony_578_marine.98bb609b.jpg";